<template>
  <span v-html="text"></span>
</template>

<script>
export default {
  props: {
    value: [Array, Number, String],
  },
  computed: {
    roles() {
      return (this.$dir.get("roles") || []).map((item) => ({ ...item }));
    },
    users() {
      return (this.$dir.get("user") || []).map((item) => ({ ...item }));
    },
    job() {
      return (this.$dir.get("job") || []).map((item) => ({ ...item }));
    },
    employee() {
      return (this.$dir.get("employee") || []).map((item) => ({ ...item })); 
    },
    text() {
      if (this.value) {
        let v;
        if (!Array.isArray(this.value)) v = [this.value];
        else v = [...this.value];

        let res = [];
        v.forEach(el => {
          if (typeof el == "object") res.push(el.user_name);
          else {
            let user = this.users.find(e => {
              return e.value == el;
            });
            let emp = this.employee.find(r => {
              return r.user_id == user?.value;
            });

            let job = this.job.find(r => {
              return r.value == emp?.job_id;
            });
            let u =
              user?.text /* +
              ` (${
                this.roles.find(r => {
                  return r.value == user?.role;
                })?.text
              })`  */ + ` (${job?.text || "???"})`;
            res.push(u);
          }
        });
        return res.join("; ");
      }
    },
  },
};
</script>
